'use strict';

var arrayMethodBoxesProperly = require('es-array-method-boxes-properly');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	var method = Array.prototype.map;
	return arrayMethodBoxesProperly(method) ? method : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.map/polyfill.js
// module id = 559
// module chunks = 31